import {API} from 'aws-amplify';
import {awsApiName} from '../../shared/amplify/amplify-utils';
import {AuditLogsResponse} from '../../entity/resource/audit-logs-response';
import {TitleAuditLogsResponse} from '../../entity/resource/title-audit-logs-response';

export class AuditLogsAgent {
  getAuditLogs = async (organizationId: string, batchId: string): Promise<AuditLogsResponse[]> => {
    return await API.get(awsApiName, `/organizations/${organizationId}/async-job-status/batch/${batchId}`, {});
  }

  getTitleAuditLogs = async (organizationId: string, titleId: string): Promise<TitleAuditLogsResponse[]> => {
    return await API.get(awsApiName, `/organizations/${organizationId}/audit-logs/title/${titleId}`, {});
  }

  getTitleAuditLogsFromS3 = async (organizationId: string, titleId: string): Promise<TitleAuditLogsResponse[]> => {
    const s3BaseUrl = process.env.REACT_APP_S3_BASE_URL;
    const s3Url = `${s3BaseUrl}/${organizationId}/audit_logs/${titleId}.json`;
    
    const response = await fetch(s3Url);
    if (!response.ok)
      return [];
    
    return await response.json();
  }
}
